import * as constants from 'client/redux/fatdi/constants';
import _ from 'lodash';
import { reduceByTypes } from 'client/redux/apiHelpers';
import { ucfirst } from 'client/helpers/misc';

const defaultState = {
  error: null,
  isAddingFastCase: false,
  isAddingFastErrand: false,
  isAddingFastOrder: false,
  isAddingTopdeskIncident: false,
  searchFields: {fastCase: '', fastErrand: '', fastOrder: '', topdeskIncident: ''},
  fastCases: {},
  fastErrands: {},
  fastOrders: {},
  topdeskIncidents: {},
};

const defaultObjectState = {
  isSyncing: false,
  isGettingObjectGraph: false,
  error: null,
  objectContainer: null,
  notices: null,
  wasLast: null,
};

const getObjectType = action => _.get(action, 'meta.objectType');
const getObjectId = action => _.get(action, 'meta.objectId');

// reduce a single object
const reduceObject = (state = defaultObjectState, action) => {
  state = reduceByTypes(constants.INSTANCE_FATDI_TEST_OBJECT_ADD, state, action, {requestProp: 'isAddingObject', successPickProps: [
    'notices',
    'fastCase',
    'fastErrand',
    'fastOrder',
    'topdeskIncident',
  ]});
  state = reduceByTypes(constants.INSTANCE_FATDI_SYNC_OBJECT, state, action, {
    requestProp: (state, action, isSyncing) => ({
      isSyncing,
      notices: null,
      error: null,
    }),
    successPickProps: ['notices', 'error'],
  });
  state = reduceByTypes(constants.INSTANCE_FATDI_TEST_OBJECT_FASTOBJECTGRAPH, state, action, {requestProp: 'isGettingObjectGraph', successProp: 'objectGraph'});
  if (action.type === constants.INSTANCE_FATDI_SYNC_OBJECT_SUCCESS) state.wasLast = 'synced';
  return state;
};

// these actions should pass to reduceObject
const objectActions = [
  ...constants.INSTANCE_FATDI_SYNC_OBJECT,
  ...constants.INSTANCE_FATDI_TEST_OBJECT_FASTOBJECTGRAPH,
  ...constants.INSTANCE_FATDI_TEST_OBJECT_ADD,
];

// reduce an object of objects keyed by id
const reduceObjects = (objects = {}, action) => {
  if (objectActions.includes(action.type)) {
    const objectId = getObjectId(action);
    return {
      ...objects,
      [objectId]: reduceObject(objects[objectId], action),
    };
  }
  switch (action.type) {
    default: return objects;
    case constants.INSTANCE_FATDI_TEST_CLEAR: return {};
    case constants.INSTANCE_FATDI_TEST_OBJECT_REMOVE: return _.omit(objects, getObjectId(action));
  }
};

export default function testReducer (state = defaultState, action) {
  state = reduceByTypes(constants.INSTANCE_FATDI_TEST_OBJECT_ADD, state, action, {
    requestProp: (state, action, isRequesting) => {
      const prop = `isAdding${ucfirst(getObjectType(action))}`;
      return {[prop]: isRequesting};
    },
    successPickProps: [],
  });
  switch (action.type) {
    default: {
      const key = getObjectType(action) + 's';
      return {
        ...state,
        [key]: reduceObjects(state[key], action),
      };
    }
    case constants.INSTANCE_FATDI_TEST_OBJECT_SEARCH_FIELD_CHANGE: return {
      ...state,
      searchFields: {
        ...state.searchFields,
        [getObjectType(action)]: getObjectId(action),
      },
    };
  }
}
